<template lang="pug">
  .contenedor-lista
    .modal.is-active(
      key="modal-editar"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      v-if="mostrarConfirmacionEliminar"
      )
      transition(
        name='fade',
        tag="div",
        )
        confirmar-accion-overlay(
          @close="mostrarConfirmacionEliminar = false"
          @do="eliminar()"
        )
          span(slot="title") {{ confirmacionEliminarTitulo }}
          span(slot="information") {{ confirmacionEliminarDescripcion }}
          i.fa.fa-video-camera(slot="topIcon")
          span(slot="primaryAction")
            template(v-if="isSendingEliminar")
              | Eliminando...
            template(v-else)
              | Eliminar
    .title
      span Gestión de cursos virtuales
    .text-right
      button.button.is-small.margin-right-5.is-primary(@click="redirigir(0)")
        span.icon.is-small
          i.fa.fa-plus
        span Nuevo
      button.button.is-small(@click="fetch")
        span.icon.is-small
          i.fa.fa-refresh
        span Refrescar

    .body
      .is-loading(v-if="isLoading")
        .icon
          i.fa.fa-spinner.fa-spin
      .information(v-else)
        template(v-if="lista.length !== 0")
          .is-desktop
            table.table.is-striped.is-bordered
              thead
                th Título
                th Descripción
                th
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'is-close': !o.activo}"
                )
                  td
                    .hint--top(:aria-label="'ID: ' + o.id") {{ o.titulo | truncateText(20) }}
                  td {{ o.descripcion | truncateText(30) }}
                  td.text-center
                    .display-flex.flex-wrap.space-around
                      button.button.is-small.m-2(@click="redirigir(o.id)")
                        span.icon.is-small
                          i.fa.fa-pencil-square-o
                        span Editar
                      button.button.is-small.is-danger.m-2(@click="confirmarEliminar(o)")
                        span.icon.is-small
                          i.fa.fa-times
                        span Eliminar
          .is-mobile
            .box(
              v-for="(o, index) in lista"
              :key="index"
            )
              .descripcion-tipo
                span.hint--top(:aria-label="'ID: ' + o.id") {{ o.titulo }}
              .motivo(v-if="o.descripcion")
                div
                  span {{ o.descripcion }}
              .botones
                button.button.is-small(@click="redirigir(o.id)")
                  span.icon.is-small
                    i.fa.fa-pencil-square-o
                  span Editar
                button.button.is-small.is-danger(@click="confirmarEliminar(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Eliminar
        div(v-else)
          .message.is-warning
            .message-body No hay cursos registrados
</template>

<script>
import ComponentConfirmarAccionOverlay from '../components/Component_Confirmar_Accion_Overlay';

import { apiGet, apiDelete, notify } from '../util/general'
export default {
  name: 'gestion-cursos-virtuales-lista',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      idSeleccionado     : null,
      confirmacionEliminarId:'',
      confirmacionEliminarTitulo:'',
      confirmacionEliminarDescripcion:'',
      mostrarConfirmacionEliminar:false,
      isSendingEliminar:''
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  mounted () {
    this.fetch()
  },
  components: {
    'confirmar-accion-overlay' : ComponentConfirmarAccionOverlay
  },
  methods: {
    confirmarEliminar (o) {
      var vm = this
      vm.confirmacionEliminarId = o.id
      vm.confirmacionEliminarTitulo = 'Eliminar curso'
      vm.confirmacionEliminarDescripcion = 'Al eliminar el curso, eliminara a los alumnos y sus notas.'

      vm.mostrarConfirmacionEliminar = true
    },
    eliminar () {
      var vm = this
      vm.isSendingEliminar = true
      apiDelete(vm, '/curso/gestion/' + vm.confirmacionEliminarId, {}, function (data) {
        notify(vm, 'success', 'Éxito', 'Curso eliminado con éxito.')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSendingEliminar = false
        vm.mostrarConfirmacionEliminar = false
        vm.fetch()
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/curso', {}, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    redirigir (id) {
      var objPush = { path: `/gestion-cursos/${id}` }
      this.$router.push(objPush)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width 500px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// c_gestion_cursos_virtuales_lista.vue?f601dd10